import type { FaireThemeEntity } from "../../entity_types/theme";

export const classic_wooden_toys_build_and_play: FaireThemeEntity = {
  token: "classic-wooden-toys-build-and-play",
  type: "theme",
  name: "Classic Wooden Toys & Build-and-Play",
  description: "",
  teaser: "",
  detail: "",
  bgColor: "#F5F0D4",
  exactProducts: true,
  retailerToken: "r_eer7xgiweo",
  productTokens: [
    "p_afrgqrhhxe",
    "p_543yjfsk2e",
    "p_b6tzqppdc4",
    "p_hk54r8prcy",
    "p_gdscg2hsey",
    "p_jqhq64vbda",
    "p_arqjuh8eyd",
    "p_3awcacr3jc",
    "p_62hdwpdj3j",
    "p_ac0uxwjy57",
    "p_57yh2dgkqf",
    "p_499ev655a2",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
